export default __webpack_public_path__ + "static/media/down_arrow.ff0b4145.svg";